import { IconButton } from "@mui/material";
import { isEqual } from "lodash";
import { ReactElement, useContext, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useRecoilValue } from "recoil";

import { PIC } from "@ryde/assets";
import {
  PageHeaderContext,
  usePageContext,
  useReportActions,
  useReportId,
} from "@ryde/redux";
import {
  isEntityServerSideFiltered,
  reportLastSearchCriteriaByReportIdAF,
} from "@ryde/shared";

import { useFiltersActiveStateReports } from "./use-filters-active-state.reports";

export const FiltersApplyReports = (): ReactElement => {
  const { entity } = usePageContext();
  const { reportId } = useReportId();
  const { onFiltersApply } = useContext(PageHeaderContext);
  const { isAnyFilterActive } = useFiltersActiveStateReports();
  const { fetchCriteria } = useReportActions();

  const reportLastSearchCriteriaAF = useRecoilValue(
    reportLastSearchCriteriaByReportIdAF(reportId),
  );

  const { t } = useTranslation();

  const onClick = (): void => {
    onFiltersApply?.();
  };

  const filterCanBeApplied = useMemo(() => {
    if (isEntityServerSideFiltered(entity)) {
      return !isEqual(reportLastSearchCriteriaAF, fetchCriteria);
    }

    return isAnyFilterActive;
  }, [entity, fetchCriteria, isAnyFilterActive, reportLastSearchCriteriaAF]);

  return (
    <IconButton
      onClick={onClick}
      title={t(`general.APPLY_FILTERS`)}
      color={filterCanBeApplied ? "primary" : "default"}
    >
      <PIC.FilterApplySvg />
    </IconButton>
  );
};
